import { render, staticRenderFns } from "./ViewUpload.vue?vue&type=template&id=f6adf71e"
import script from "./ViewUpload.vue?vue&type=script&lang=js"
export * from "./ViewUpload.vue?vue&type=script&lang=js"
import style0 from "./ViewUpload.vue?vue&type=style&index=0&id=f6adf71e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports